export const checkIfKeyIsValid = (key) => {
    if (key.includes(' ')) {
        return false;
    }
    if (key.toLowerCase() !== key) {
        return false;
    }
    return true;
};
